import React, { useEffect, useState } from "react";
import {
  ITotalByMonth,
} from "../../../common/accounts2";
import "../styles/Accounts.css";
import "../styles/GetPayments.css";
import { Button,  Modal, Spinner } from "react-bootstrap";
import { kopecks2rubStr } from "../../../common/functions";
import { getUuidAndSession } from "../../../common/localStorage";
import axios from "axios";
import { $SiteColors } from "../../../common/config/company-atts";
import { getCustomUserAgent } from "../../../common/customUserAgent";
import { toast } from "react-toastify";

interface IGetPayments {
  setShowPaymentsClicked: React.Dispatch<React.SetStateAction<boolean>>;
  accountId: number,
  accountNum: string,
  indebtedness:string,
  total:ITotalByMonth,
  comId:number
  
}

export const GetPaymentsPhis = ({setShowPaymentsClicked, accountId, accountNum,indebtedness,total,comId}: IGetPayments) => {

  const [agreesmantCheck,setAgreesmentCheck]=useState(false)
  const [show, setShow] = useState(true)

  const [loading, setLoading] = useState(false)
  console.log(indebtedness)

  //Для оплаты
  const [minCommission,setMinCommission]=useState('')
  const [Commission,setCommission]=useState(600)
  const [order,setOrder]=useState('')
  const [code,setCode]=useState('')
  const [paymentId,setPaymentId]=useState('')
  const [openDialog,setOpenDialog]=useState(false)
  const [paySumm,setPaySumm]=useState('')
  const [agreesmentLink,setAgreesmentLink]=useState(null)



  const handleClose = () => {
    setShow(false)
    setShowPaymentsClicked(false)
  }

 
  useEffect(()=>{
      if(parseInt(indebtedness.replace(/[₽,\s]/g,''))>=0){
        onPaySwummChange('0')
      }
      else{
           onPaySwummChange(indebtedness.replace(/[₽,-\s]/g,''))

      }
   
    axios.post("https://izba.kras-abs.ru/api/v3/pay/purposesAbs", {
        ...getUuidAndSession(),
        accountId: accountId,
        },{
        headers: {
          "Custom-User-Agent": getCustomUserAgent(),
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        }
        }).then((resp) => {
          console.log(resp)
            setAgreesmentLink(resp.data.payPurposes[0].LinkAgreement);
            setCode(resp.data.payPurposes[0].code)
            setPaymentId(resp.data.payPurposes[0].id)
          })


  },[])

  const onPaySwummChange=(e:string)=>{
    setOpenDialog(false)
    if(e.replace(/[0-9,]/g,'').length===0){
      console.log(e)
      e = e.split(',').join('');
      e = e.replace(/^0+(?=(\d*))/i,"")
      console.log(e)
      while(e.length<3){
          e="0"+e;
          console.log(e)
      }
      
      var newstr= e.replace(/\d+(?=(\d{2})+(?!\d))/,'$&,')
      setPaySumm(newstr)
    }
  }

  const AcceptButton=async()=>{
    
    var PaySum = paySumm.replace(/[-\s,₽]/g,'')
    console.log(PaySum)
    
    if(PaySum==="000"){
      toast.error("Сумма оплаты не должна быть равна нулю")
      return
    }
    setLoading(true)
        axios.post("https://izba.kras-abs.ru/api/v3/pay/commissionAbs", {
        ...getUuidAndSession(),
        accountId: accountId.toString(),
        amount:PaySum.toString(),
        code:code,
        payPurposeId:paymentId.toString()
        },{
            headers: {              
          "Custom-User-Agent": getCustomUserAgent(),
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
            }
        }).then((resp) => {
            console.log(resp.data);
            setCommission(resp.data.commission);
            setMinCommission(resp.data.commission_fix);
            setOrder(resp.data.order)
            setLoading(false)
            setOpenDialog(true)
        })
            
        setLoading(false)
            setOpenDialog(true)

    if(openDialog){
      PaySum = paySumm.replace(/[-\s,₽]/g,'')
      axios.post("https://izba.kras-abs.ru/api/v3/pay/payUrlAbs", {
        ...getUuidAndSession(),
        order:order,
        amount:PaySum.toString(),
        commission:Commission.toString(),
        code:code
        
      },{
        headers: {                
          "Custom-User-Agent": getCustomUserAgent(),
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        }
      }).then((resp) => {console.log(resp.data.url);
        window.location.href=resp.data.url
      })
    }
  }

  return (
    <Modal size="sm"  show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <span className="a_o_title">Оплатить</span>
      </Modal.Header>
      <Modal.Body className="a_o_periods_list_con">
        <div>
          <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
            <span>Задолженность по ЛС:</span>
            <span>{indebtedness}</span>
          </div>
          <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
            <span> {total?"Начисленно за"+total.periodName+":": "Начисления не обнаружены"}</span>
            <span>{total?kopecks2rubStr(total.monthAmount):null}</span>
          </div>
          <div style={{margin:"0.5rem 0"}}>
            <h1 style={{fontSize:"20px", fontWeight:300, textAlign:"center"}}>
              К оплате:
              <input type="text" className="a_o_gp_input" value={paySumm} onChange={e=>onPaySwummChange(e.target.value)}/>
              <span style={{fontWeight:700, textDecoration:'underline'}}>₽</span>
              </h1>
          </div>
          <div style={{display:"flex", flexDirection:'row'}}>
            <div style={{margin:"0.2rem 1rem 0.2rem  0"}}>
              <i onClick={()=>setAgreesmentCheck(!agreesmantCheck)}style={agreesmantCheck?{color:'green', transition:'0.3s'}:{color:'gray', transition:'0.3s'}} className={agreesmantCheck?"fas fa-check-circle":"far fa-circle"}></i>
            </div>
            <div>
              <p style={{fontSize:'12px', lineHeight:"1rem", margin:'0'}}>Я прочитал<a href={agreesmentLink!==null?agreesmentLink:undefined}> условия сервиса</a> и согласен с ними</p>
            </div>
          </div>
       
        <div style={openDialog&&!loading?{height:"5rem", overflow:'hidden', marginTop:"1rem",transition:"0.3s"}:{height:"0rem ", overflow:'hidden', transition:'0.3s'}}>
                Коммиссия составит {kopecks2rubStr(Commission)}.
                Сумма платежа составит {kopecks2rubStr(parseInt(paySumm.replace(/[-\s,₽]/g,''))+Commission)+". "}
                {Commission<=parseInt(minCommission)?Commission!==0?"Минимальная коммиссия составляет "+ kopecks2rubStr(parseInt(minCommission))+".":null:null}
                Продолжить оплату?
              </div>
          </div>
             
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={()=>AcceptButton()}  disabled={!agreesmantCheck}  variant="default" className="a_o_btn_get_payments" style={{background: $SiteColors.getState().backBtnSubmit}} >{loading? <Spinner animation="border" size="sm" style={{margin: "auto 10px auto 0"}}></Spinner> :"Оплатить"}</Button> 
     
      </Modal.Footer>
     
    </Modal>
  );
};
